<template>
  <div>
    <div style="border:1px solid #ededed; margin: 5px;padding-top: 5px;">
      <el-form-item
        label="合同名称"
        :rules="{
            required: false, message: '合同名称不能为空', trigger: 'blur'
        }"
      >
        <el-input v-model="item.contractName" style="width: 165px;"></el-input>
      </el-form-item>
      <el-form-item
        label="合同号"
        :rules="[
             {required: false, message: '合同号不能为空', trigger: 'blur'},
          ]"
      >
        <el-input v-model="item.contractNo" style="width: 165px;"></el-input>
      </el-form-item>
      <el-form-item
        label="合同年月"
        :rules="[
             {required: false, message: '合同年月不能为空', trigger: 'blur'},
          ]"
      >
        <el-date-picker v-model="item.contractYear" type="date" placeholder="选择日期"
                        style="width: 165px;">
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="合同状态"
      >
        <el-select v-model="item.contractStat" style="width: 165px;">
          <el-option label="未生效" :value="0"/>
          <el-option label="已生效" :value="5"/>
          <el-option label="已过期" :value="9"/>

        </el-select>
      </el-form-item>
      <div>
        <el-form-item
          label="合同开始时间"
        >
          <el-date-picker v-model="item.contractBeginTime" type="date" placeholder="选择日期"
                          style="width: 165px;" :picker-options="pickerOptions0"
                          @change="changeDate">
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="合同结束时间"
        >
          <el-date-picker v-model="item.contractEndTime" type="date" placeholder="选择日期"
                          style="width: 165px;" :picker-options="pickerOptions1"
                          @change="changeDate">
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="合同签署时间"
        >
          <el-date-picker v-model="item.contractSignTime" type="date" placeholder="选择日期"
                          style="width: 165px;">
          </el-date-picker>
        </el-form-item>
      </div>
      <div style="position: relative;">
        <el-form-item
          label="合同凭证"
        >
          <div class="form_picture"
               style="display: flex;flex-direction: row-reverse;align-items: center;">
            <div @click="showVideo = true" class="videoAdd"><i class="el-icon-plus"></i></div>
            <!-- 多个文件 -->
            <div style="display: flex; flex-wrap: wrap;">
              <div class="videoP" v-for="item1 in item.fileDTOList" :key="item1.url" style="margin-right: 10px">

                <div style="width:30%;    position: relative;" class="videoImg">
                  <el-image style="width: 50px; height: 60px"
                            :src="require('@/views/dialogCommon/htpz.jpg')"
                            fit="fit"></el-image>
                  <div @click="() => {showPreview = true; previewFileUrl = item1.url}" class="imgY"><i class="el-icon-tickets"></i></div>
                </div>
                <div style="width:70%;display:flex;flex-direction: column;justify-content: space-between;align-items: flex-end;">
                  <div>
                    <span style="width: 80% !important; height: 70%; padding-right:8px; overflow: hidden">{{ item1.name.length > 8 ? item1.name.slice(0, 7) + '...' : item1.name }}</span>
                    <span style="width: 10%;" @click="handleDelete(item1.url)">
                    <el-tooltip class="item" effect="dark" content="删除" placement="top">
                      <i class="el-icon-close"></i>
                    </el-tooltip>
                  </span>
                  </div>
                  <div @click="handleDownload(item1.name, item1.url)">
                    <el-tooltip class="item" effect="dark" content="下载" placement="top">
                      <i class="el-icon-download"></i>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="电子合同">
          <div v-if="currentCompanyShotName===companyConfig.NIU_EN_TAI" class="form_picture" style="display: flex;">
            <div style="display: flex; flex-wrap: wrap;" v-if="siteId">
              <el-button @click="showDialog = true" v-if="!item.contractEFile">生成合同</el-button>
              <div class="videoP" v-else>
                <div style="width:30%; position: relative;" class="videoImg">
                  <el-image style="width: 50px; height: 60px"
                            :src="require('@/views/dialogCommon/htpz.jpg')"
                            fit="fit"></el-image>
                  <div @click="() => {showPreview = true; previewFileUrl = item.contractEFile}"
                       class="imgY"><i class="el-icon-tickets"></i></div>
                </div>
                <div style="width:70%;display:flex;flex-direction: column;justify-content: space-between;align-items: flex-end;">
                  <div>
                    <span style="width: 80% !important; height: 70%; padding-right:8px; overflow: hidden">{{ item.contractEFileName }}</span>
                    <span style="width: 10%;" @click="() => {item.contractEFile = null; item.contractEFileName = null}">
                    <el-tooltip class="item" effect="dark" content="删除" placement="top">
                      <i class="el-icon-close"></i>
                    </el-tooltip>
                  </span>
                  </div>
                  <div @click="handleDownload(1, 1)">
                    <el-tooltip class="item" effect="dark" content="下载" placement="top">
                      <i class="el-icon-download"></i>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </div>
    </div>
    <text2Dialog v-if="showVideo" @commitVideo="commitVideo" :visiable.sync="showVideo" multi="true"/>

    <!-- 纽恩泰合同 -->
    <niu-en-tai-contract :visiable.sync="showDialog" v-if="showDialog" @pdfCreate="pdfCreate" :param="{id: siteId}"/>

    <!-- 文件预览 -->
    <Preview v-if="showPreview"
             @closeD="() => {showPreview = false; previewFileUrl = null}"
             :visiable.sync="showPreview"
             :imgVisbleURL="previewFileUrl"
    />
  </div>
</template>
<script>
import text2Dialog from "@/views/dialogCommon/text2Dialog.vue";
import NiuEnTaiContract from "@/views/dialogCommon/niuEnTaiContract.vue";
import Preview from "@/views/dialogCommon/PreviewDialog.vue";
import {companyMixins} from "@/mixins/tabChang";
import {companyConfig} from "@/config/companyShotName";

export default {
  name: 'contractItem',
  computed: {
    companyConfig() {
      return companyConfig
    }
  },
  components: {Preview, NiuEnTaiContract, text2Dialog},
  mixins: [companyMixins],
  props: ['item', 'siteId'],
  data() {
    return {
      showVideo: false,
      showDialog: false,
      showPreview: false,
      previewFileUrl: null,
    }
  },
  watch: {
    item: {
      handler(newVal, oldVal) {
        this.$emit('update:item', newVal)
      }
    },
    deep: true
  },
  methods: {
    pdfCreate(url) {
      this.item.contractEFile = url
      this.item.contractEFileName = '合同原件'
    },


    // 文件下载
    handleDownload(name, url) {
      this.$mask.open()
      console.log(name, url, "下载");
      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()
      this.$mask.close()
    },

    handleDelete(url) {
      console.log('删除凭证', url)
      let list = this.item.fileDTOList
      list = list.filter(item1 => item1.url != url)
      this.item.fileDTOList = list
    },

    changeDate() {
      if (this.item.contractBeginTime && this.item.contractEndTime) {
        let date = new Date(this.item.contractBeginTime);
        let date1 = new Date(this.item.contractEndTime);

        if (date > date1) {
          this.$message.error("合同开始不能大于结束时间")
          this.item.contractEndTime = null
        }
      }
    },

    // 预览
    openVideo(value) {
      let host = window.location.hostname
      console.log(host, "域名111");

      let url = `https://` + host + value
      console.log(url, "url 名字");
      window.open("https://view.xdocin.com/view?src=" + encodeURIComponent(url));
    },

    // 文件上传文件
    commitVideo(data) {
      console.log('选中的多文件数据', data)
      let combinedArray = []
      if (this.item.fileDTOList && this.item.fileDTOList.length > 0) {
        combinedArray = [...this.item.fileDTOList]
      }
      if (data && data.length > 0) {
        combinedArray.push(...data)
      }
      console.log(combinedArray)
      if (combinedArray.length > 3) {
        combinedArray = combinedArray.splice(combinedArray.length - 3, combinedArray.length)
      }
      console.log(combinedArray)
      this.item.fileDTOList = combinedArray
    },
  }
}
</script>
<style>
.videoAdd {
  width: 40px;
  height: 40px;
  margin-left: 10px;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  text-align: center;
  line-height: 40px;

}

.videoP {

  margin-bottom: 10px;
  padding: 5px;
  border: 1px solid #e8e8e8;
  min-width: 200px;
  height: 70px;
  display: flex;
  justify-content: space-between;
  border-radius: 3px;
}

.imgY {
  position: absolute;
  height: 60px;
  width: 50px;
  top: 0px;
  line-height: 60px;
  left: 2px;
  background-color: #c6c2c2;
  opacity: 0.9;
  text-align: center;
  line-height: 60px;
  font-size: 30px;
  display: none;
}

.videoImg:hover .imgY {

  display: block
}
</style>
